import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FieldAgentClient, ProductPer, Branch } from 'ep-bt-field-agent-proxy';
import { BistrackConfig, BranchAccess } from 'ep-bt-controls';

@Component({
  selector: 'epbt-fa-product-per-list',
  templateUrl: './epbt-fa-product-per-list.component.html',
  styleUrls: ['./epbt-fa-product-per-list.component.scss']
})
export class EpbtFaProductPerListComponent implements OnInit {

  @Input() productPer: any;

  @Input()
  selectedProductPerItem: ProductPer;

  @Input() branchID: number;
  @Input() productID: number;
  @Input() purchasing: boolean;

  @Output() selectedProductPerIdChange = new EventEmitter<any>();

  constructor(private client: FieldAgentClient) { }

  onSelectionChange(selectedValue: any) {
    this.selectedProductPerItem = selectedValue;
    this.selectedProductPerIdChange.emit(this.selectedProductPerItem);
  }

  ngOnInit() {
    this.getProductPer();
  }

  getProductPer() {
    //this.client.getProductPers(this.branchID, this.productID, this.purchasing).subscribe(res => {
      
    this.client.getProductPers(this.branchID, this.productID, true).subscribe(res => {
      this.productPer = res;
      if (this.productPer.length > 0) {
        var result = this.productPer.findIndex(x => x.defaultPer == true);
        this.selectedProductPerItem = this.productPer[result];
        this.selectedProductPerIdChange.emit(this.productPer[result]);
      }
    });
  }
}
